import { useApolloClient } from "@apollo/client";
import { useAppDispatch, useAppSelector } from "../../../Store";
import { useCallback, useMemo, useState } from "react";
import Graph_QL, { DynamicDataObk, GqlHook_Returns, StateDataObject } from "..";
import { AttentionLogItem } from "./attentionLogSlice";
import { filterByConnection } from "../filterByConnection";
import { BasicQueryInfoInput } from "../FeedDataCalls/GQLCalls/getFeedComponentsCall";
import { AttentionLogResponse, GET_ATTENTION_LOGS } from "./GQLCalls/getAttentionLogs";
import { gqlActions } from "../gqlData_Reducer";
import { DISMISS_ATTENTION_LOG, DismissAttentionLogResponse } from "./GQLCalls/dismissAttentionLogs";
import { noop } from "lodash";

export const useAttentionLog = (connection: Graph_QL.GQLCons): GqlHook_Returns<AttentionLogItem, BasicQueryInfoInput> => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();
  const [, setCursorId] = useState(-1);

  const attentionLogState = useAppSelector(({graphQlData:{domain}}) => domain.attentionLog);
  const {fullState} = useMemo(() => {
    const state = filterByConnection(attentionLogState, Graph_QL.ToArr(connection)) as Record<string, AttentionLogItem>
    return Object.entries(state).reduce((accumulator, [key, data]) => {
      if (data.data) {
        const value = {...data.data, domain:key}; 
        accumulator.data = accumulator.data.concat(value)
      }
      return accumulator
    },{fullState: state, data: []} as StateDataObject<AttentionLogItem>)
  },[connection, attentionLogState]);

  const getAttentionLogs = async (input: BasicQueryInfoInput, specific?: Graph_QL.GQLCons) => {
    const usedConnection = specific?.connection ? specific.connection : connection.connection;
    try {
      client.query<AttentionLogResponse>({query: GET_ATTENTION_LOGS, variables: {input, ...usedConnection}, fetchPolicy: input.ids && input.ids?.length > 0 ? "network-only" : undefined})
        .then((e) => {
          if (e && e.data) {
            dispatch({type: String(gqlActions.domain.attentionLog.maintained), payload: {con: connection?.connection, data: e.data.controller.attentionLogs}});
            setCursorId(e.data.controller.attentionLogs.at(-1)?.attention_log_id ?? -1)
          }
        }).catch((error) => {console.log(error);})
    } catch (error) {
      console.log(error);
    }
  }
  
  const maintainEntries = useCallback(async (logDataToDismiss?: Partial<DynamicDataObk<{logs: number[]}>>) => {
    const logs = logDataToDismiss?.data;

    try {
      if (logs) {
        client.mutate<DismissAttentionLogResponse>({mutation: DISMISS_ATTENTION_LOG, variables: {...connection.connection, logs}})
          .then((response) => {
            if (response && response.data) {
              dispatch({type: String(gqlActions.domain.attentionLog.maintained), payload: {con: connection?.connection, data: response.data.controller.dismissAttentionLog}});
            }
          })
      }
    } catch (error) {
      console.log(error);
    }
  },[client, connection.connection, dispatch])
  

  return {call: getAttentionLogs, fetchMore: noop, deleteEntries: noop, data: fullState, maintainEntries}
} 

